import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Col,
  ControlLabel,
  FormGroup,
  HelpBlock,
  Row,
} from 'react-bootstrap';
import { CompactPicker } from 'react-color';
import { Field } from 'react-final-form';
import {
  CUSTOM_FONTS,
  DEFAULT_COLOR_PALETTE,
} from '../../../../containers/change-insights/utils/index.jsx';
import BrandFontSelect from '../../../change-insights/BrandFontSelect.jsx';
import CustomTooltip from '../../../CustomTooltip.jsx';
import FieldGroup from '../../../FieldGroup.jsx';
import { FormError } from '../../../FormError.jsx';
import QuestionBlueIcon from '../../../icons/QuestionBlueIcon.jsx';
import { UploadIcon } from '../../../icons/UploadIcon.jsx';
import CheckboxAdapter from '../../../CheckboxAdapter.jsx';
import { getOrgSlug } from '../../../../lib/utils.js';

const OrgCompanySettingsForm = (props) => {
  const {
    submitError,
    submitFailed,
    submitting,
    handleSubmit,
    handleImageSelect,
    handleIconLogoSelect,
    handleChangeData,
    handleCancel,
    onDeleteLogo,
    onDeleteIcon,
    values,
    errors,
  } = props;
  const [fileName, setFileName] = useState('');
  const inputRef = useRef();
  const file = inputRef.current ? inputRef.current.files[0] : null;
  const [iconName, setIconName] = useState('');
  const inputIconRef = useRef();
  const icon = inputIconRef.current ? inputIconRef.current.files[0] : null;

  const isIconStock = (url) => {
    // Check if the URL contains '/active_storage/'
    if (url.includes('/active_storage/')) {
      return false;
    }
    return true;
  };

  const handleDeleteLogo = () => {
    onDeleteLogo();
    inputRef.current.value = '';
    values.logos = '';
    setFileName('');
  };
  const handleDeleteIcon = () => {
    onDeleteIcon();
    inputIconRef.current.value = '';
    values.icon = '';
    setIconName('');
  };

  useEffect(() => {
    if (file) {
      setFileName(file.name);
    }
  }, [file]);

  useEffect(() => {
    if (icon) {
      setIconName(icon.name);
    }
  }, [icon]);

  return (
    <React.Fragment>
      <Row className="m-b-60">
        <Col xs={12}>
          <div
            className="component-sm component-bg-blue component-hide-border component-margin-bottom flex row"
            style={{ marginLeft: '0' }}
          >
            <h3>Brand Elements</h3>
          </div>
          <Row style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Col xs={6}>
              {values.logos ? (
                <div
                  className="stakeholder-profile-avatar m-b-30"
                  style={{ maxWidth: '100px', borderRadius: '14px' }}
                >
                  <img
                    src={values.logos}
                    style={{ width: '-webkit-fill-available' }}
                    alt="organization-logo"
                    sizes="300x290"
                  />
                </div>
              ) : null}
              <FormGroup className="flex flex-col flex-align-start">
                <div className="flex flex-align-center m-b-8">
                  <ControlLabel style={{ marginBottom: 0 }}>Logo</ControlLabel>
                  <CustomTooltip
                    placement="bottom"
                    tooltip={
                      <div style={{ maxWidth: '256px' }}>
                        <strong>
                          <h5
                            style={{
                              fontSize: '14px',
                              fontWeight: '600',
                              lineHeight: '20px',
                              color: '#153142',
                            }}
                            className="m-b-8"
                          >
                            Upload Logo
                          </h5>
                        </strong>
                        <p
                          style={{
                            fontSize: '12px',
                            fontWeight: '400',
                            lineHeight: '20px',
                            color: '#7F8FA4',
                          }}
                          className="m-b-0 text-muted"
                        >
                          The full-sized version of your logo.
                          <br />
                          Allowed formats: .jpeg, .png, .jpg
                          <br />
                          Max file size: 10Mb
                        </p>
                      </div>
                    }
                    id="tooltip"
                  >
                    <Button
                      aria-label="View Support for Change modal"
                      type="button"
                      className="flex flex-align-center m-l-8 btn-last-update-icon"
                    >
                      <QuestionBlueIcon />
                    </Button>
                  </CustomTooltip>
                </div>
                <div className="m-b-8 w-100" style={{ maxWidth: '360px' }}>
                  <div className="flex flex-justify">
                    <label
                      htmlFor="logos"
                      className="file-input w-100"
                      style={{ maxWidth: 'calc(100% - 44px)' }}
                    >
                      <UploadIcon color="#7F8FA4" />
                      <span className="m-l-4">Upload</span>
                      <input
                        style={{ display: 'none' }}
                        ref={inputRef}
                        id="logos"
                        type="file"
                        accept=".jpeg, .png, .jpg"
                        onChange={handleImageSelect}
                      />
                    </label>
                    <button
                      type="button"
                      // disabled={!values.logos}
                      className="btn-delete btn btn-default m-l-8"
                      onClick={handleDeleteLogo}
                    ></button>
                  </div>
                  <div className="file-name m-t-8">{fileName}</div>
                </div>
                {submitFailed && errors.logos && (
                  <FormGroup validationState="error">
                    <HelpBlock>{errors.logos}</HelpBlock>
                  </FormGroup>
                )}
                <p className="m-0 text-muted">
                  Allowed formats: .jpeg, .png, .jpg
                </p>
                <p className="text-muted">Max file size: 10Mb</p>
              </FormGroup>
            </Col>
            <Col xs={6}>
              {values.icon && !isIconStock(values.icon) ? (
                <div
                  className="stakeholder-profile-avatar m-b-30"
                  style={{ maxWidth: '100px', borderRadius: '14px' }}
                >
                  <img
                    src={values.icon}
                    style={{ width: '-webkit-fill-available' }}
                    alt="organization-logo"
                    sizes="300x290"
                  />
                </div>
              ) : null}
              <FormGroup className="flex flex-col flex-align-start">
                <div className="flex flex-align-center m-b-8">
                  <ControlLabel style={{ marginBottom: 0 }}>Icon</ControlLabel>
                  <CustomTooltip
                    placement="bottom"
                    tooltip={
                      <div style={{ maxWidth: '256px' }}>
                        <strong>
                          <h5
                            style={{
                              fontSize: '14px',
                              fontWeight: '600',
                              lineHeight: '20px',
                              color: '#153142',
                            }}
                            className="m-b-8"
                          >
                            Upload Icon
                          </h5>
                        </strong>
                        <p
                          style={{
                            fontSize: '12px',
                            fontWeight: '400',
                            lineHeight: '20px',
                            color: '#7F8FA4',
                          }}
                          className="m-b-0 text-muted"
                        >
                          A smaller representation of your logo. It must be
                          square with a max size 10Mb.
                          <br />
                          Allowed formats: .jpeg, .png, .jpg.
                        </p>
                      </div>
                    }
                    id="tooltip"
                  >
                    <Button
                      aria-label="View Support for Change modal"
                      type="button"
                      className="flex flex-align-center m-l-8 btn-last-update-icon"
                    >
                      <QuestionBlueIcon />
                    </Button>
                  </CustomTooltip>
                </div>
                <div className="m-b-8 w-100" style={{ maxWidth: '360px' }}>
                  <div className="flex flex-justify">
                    <label
                      htmlFor="logo"
                      className="file-input w-100"
                      style={{ maxWidth: 'calc(100% - 44px)' }}
                    >
                      <UploadIcon color="#7F8FA4" />
                      <span className="m-l-4">Upload</span>
                      <input
                        style={{ display: 'none' }}
                        ref={inputIconRef}
                        id="logo"
                        type="file"
                        accept=".jpeg, .jpg, .png, .svg"
                        onChange={handleIconLogoSelect}
                      />
                    </label>
                    <button
                      type="button"
                      // disabled={!values.logos}
                      className="btn-delete btn btn-default m-l-8"
                      onClick={handleDeleteIcon}
                    ></button>
                  </div>
                  <div className="file-name m-t-8">{iconName}</div>
                </div>
                {submitFailed && errors.icon && (
                  <FormGroup validationState="error">
                    <HelpBlock>{errors.icon}</HelpBlock>
                  </FormGroup>
                )}
                <p className="m-0 text-muted">
                  Allowed formats: .jpeg, .png, .jpg, .svg
                </p>
                <p className="text-muted">Max file size: 10Mb</p>
              </FormGroup>
            </Col>
          </Row>
        </Col>
      </Row>
      <div
        className="component-sm component-bg-blue component-hide-border component-margin-bottom flex row m-b-32"
        style={{ marginLeft: '0' }}
      >
        <h3>Feedback Forms Branding</h3>
      </div>
      <p className="text-muted m-b-32">
        Choose a color scheme and font that align with your organization's
        branding to customize the appearance of surveys and assessments.
      </p>

      <Row>
        <Col xs={12}>
          <Col xs={6} style={{ padding: '0' }}>
            <div className="m-b-24">
              <h4 className="m-b-8 text-muted">Brand color</h4>
              <CompactPicker
                colors={DEFAULT_COLOR_PALETTE}
                color={values.brandColor}
                onChangeComplete={(color) =>
                  handleChangeData(color.hex, 'brandColor')
                }
              />
              <p className="m-t-8 text-muted">
                Select a color from the predefined palette or enter your
                <br /> brand's hex code.
              </p>
            </div>
          </Col>
          <Col xs={6}>
            <div>
              <BrandFontSelect
                fonts={CUSTOM_FONTS}
                selectedFont={values.fontName}
                handleSelect={handleChangeData}
              />
              <p className="m-b-24 text-muted">
                Select font to use in feedback forms
              </p>
            </div>
          </Col>
        </Col>
      </Row>
      <Row className="m-b-32">
        <Col xs={12}>
          <div
            className="component-sm component-bg-blue component-hide-border component-margin-bottom flex row m-b-32"
            style={{ marginLeft: '0' }}
          >
            <h3>Custom Terminology</h3>
            <CustomTooltip
              placement="bottom"
              tooltip={
                <div style={{ maxWidth: '256px' }}>
                  <strong>
                    <h5
                      style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        lineHeight: '20px',
                        color: '#153142',
                      }}
                      className="m-b-8"
                    >
                      Custom Terminology
                    </h5>
                  </strong>
                  <p
                    style={{
                      fontSize: '12px',
                      fontWeight: '400',
                      lineHeight: '20px',
                      color: '#7F8FA4',
                    }}
                    className="m-b-0 text-muted"
                  >
                    Customizing naming is useful to adapt the project's
                    terminology to the specific needs of an organization. This
                    allows for a more understandable and user-friendly
                    interface, as terms will be used according to the unique
                    language and context of the organization.
                  </p>
                </div>
              }
              id="tooltip"
            >
              <Button
                aria-label="View Support for Change modal"
                type="button"
                className="flex flex-align-center m-l-8 btn-last-update-icon"
              >
                <QuestionBlueIcon />
              </Button>
            </CustomTooltip>
          </div>
        </Col>
        <Col xs={6}>
          <Field
            id="customParentPortfolioName"
            name="customParentPortfolioName"
            placeholder="Parent Portfolio"
            label="Change “Parent Portfolio” to:"
            maxLength={31}
            component={FieldGroup}
          />
          <Field
            id="customPortfolioName"
            name="customPortfolioName"
            placeholder="Portfolio"
            label="Change “Portfolio” to:"
            maxLength={31}
            component={FieldGroup}
          />
          <Field
            id="customProjectName"
            name="customProjectName"
            placeholder="Project"
            label="Change “Project” to:"
            maxLength={31}
            component={FieldGroup}
          />

          <Field
            id="customInitiativeName"
            name="customInitiativeName"
            placeholder="Initiative"
            label="Change “Initiative” to:"
            maxLength={31}
            component={FieldGroup}
          />
          <Field
            id="customActivityName"
            name="customActivityName"
            placeholder="Activity"
            label="Change “Activity” to:"
            maxLength={31}
            component={FieldGroup}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <div
            className="component-sm component-bg-blue component-hide-border component-margin-bottom flex row m-b-32"
            style={{ marginLeft: '0' }}
          >
            <h3>Integrations</h3>
            <CustomTooltip
              placement="bottom"
              tooltip={
                <div style={{ maxWidth: '256px' }}>
                  <strong>
                    <h5
                      style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        lineHeight: '20px',
                        color: '#153142',
                      }}
                      className="m-b-8"
                    >
                      Integrations
                    </h5>
                  </strong>
                  <p
                    style={{
                      fontSize: '12px',
                      fontWeight: '400',
                      lineHeight: '20px',
                      color: '#7F8FA4',
                    }}
                    className="m-b-0 text-muted"
                  >
                    Integrations enable you to make third-party applications
                    part of your ChangeSync workflow. If the available
                    integrations don't meet your needs, please contact your
                    account manager.
                  </p>
                </div>
              }
              id="tooltip"
            >
              <Button
                aria-label="View Support for Change modal"
                type="button"
                className="flex flex-align-center m-l-8 btn-last-update-icon"
              >
                <QuestionBlueIcon />
              </Button>
            </CustomTooltip>
          </div>
        </Col>
      </Row>

      <Row className="m-b-60">
        <Col xs={12}>
          <div className="component component-border-top component-border-left component-border-right">
            <Row>
              <Col xs={12}>
                <h2 className="m-b-24 text-muted">Okta Single Sign-On</h2>
              </Col>
              <Col xs={12}>
                <Field
                  id="useOktaSso"
                  name="useOktaSso"
                  label="Enable SSO"
                  type="checkbox"
                  className="m-0"
                  component={CheckboxAdapter}
                />
              </Col>
              {values.useOktaSso ? (
                <React.Fragment>
                  <Col xs={6}>
                    <Field
                      id="issuerUri"
                      name="issuerUri"
                      label="Issuer URI:"
                      placeholder="https://your-domain.okta.com/oauth2/default"
                      customClass="m-t-16"
                      component={FieldGroup}
                    />
                    <Field
                      id="clientId"
                      name="clientId"
                      label="Client ID:"
                      placeholder="0oatc435ftuXmS1Ro697"
                      customClass="m-b-0"
                      component={FieldGroup}
                    />
                  </Col>

                  <Col xs={6}>
                    <h4 className="m-b-8 m-t-16 text-muted">
                      Integration instructions
                    </h4>
                    <ol style={{ paddingLeft: '22px' }}>
                      <li className="text-muted">
                        In Okta, create a Single-Page Application under
                        Applications → Create App Integration → OIDC - SPA.
                      </li>
                      <li className="text-muted">
                        Set the redirect URI to: <br />
                        https://login.changesync.com/login/callback
                      </li>
                      <li className="text-muted">
                        Copy and paste the app’s Client ID and Issuer URI (found
                        under the app’s General settings).
                      </li>
                      <li className="text-muted">
                        In your Okta dashboard, create a custom application tile
                        and set the Initiate Login URL to: <br />
                        https://login.changesync.com/sso?organization=
                        {getOrgSlug()}
                      </li>
                    </ol>
                  </Col>
                </React.Fragment>
              ) : null}
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {submitFailed && submitError ? (
            <FormError submitError={submitError} />
          ) : null}
          <div className="flex">
            <Button onClick={handleCancel}>Cancel</Button>
            <Button
              className="m-l-12"
              bsStyle="primary"
              disabled={submitting}
              onClick={handleSubmit}
            >
              {submitting ? 'Saving...' : 'Save'}
            </Button>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default OrgCompanySettingsForm;
